// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Přesunuto ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Akce ' + p['label'] + ' byla dokončena',
  accButtonProgressStatus: (p: { label: string }) => 'Probíhá akce ' + p['label'],
  accColorPalette: () => 'Paleta barev',
  accColorSwatch: () => 'Barevný vzorník',
  accCommandKey: () => 'Příkaz',
  accContextMenuLabel: () => 'akce',
  accControlKey: () => 'Zavřít',
  accPositionAfter: () => 'po',
  accPositionBefore: () => 'před',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Stiskněte a podržte klávesy ' +
    p['keyPressed'] +
    ' a Shift a poté pomocí kláves se šipkami změňte pořadí.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Zadejte datum dokončení takto: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Zadejte měsíc a rok takto: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Popisek',
  chart_labelGroup: () => 'Skupina',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Hodnota',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Vyberte hodnotu.',
  checkbox_helpForCheckbox: () => 'Nápověda pro zaškrtávací políčko',
  checkbox_requiredMessageDetail: () => 'Vyberte hodnotu.',
  checkbox_selected: () => 'Zaškrtávací políčko zaškrtnuto',
  checkbox_unselected: () => 'Zaškrtávací políčko nezaškrtnuto',
  close: () => 'Zavřít',
  collection_apply: () => 'Použít',
  collection_cancel: () => 'Zrušit',
  collection_loaded: () => 'Načteno',
  collection_loading: () => 'Načítání',
  collection_noData: () => 'Žádná data pro zobrazení.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Změnit velikost sloupce',
  collection_resizeColumnMenu: () => 'Změnit velikost sloupce...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Zadejte číslo v rozsahu ' + p['MIN'] + ' až ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Vybrat všechny řádky',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vybrat řádku ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Vzestupně',
  collection_sortColumnMenu: () => 'Seřadit sloupec',
  collection_sortDescendingSubMenu: () => 'Sestupně',
  collection_sortDisabled: () => 'Nelze řadit',
  collection_sortEnabled: () => 'Seřaditelné',
  collection_width: () => 'Šířka',
  colorPicker_label: () => 'Výběr barvy',
  confirmation: () => 'Potvrzení',
  datePicker_currentDate: () => 'Aktuální datum',
  datePicker_goToToday: () => 'Přejde na dnešní den',
  datePicker_label: () => 'Nástroj pro výběr data',
  datePicker_month: () => 'Měsíc',
  datePicker_months: () => 'Měsíce',
  datePicker_next: () => 'Další',
  datePicker_nextDecade: () => 'Následující desetiletí',
  datePicker_nextMonth: () => 'Následující měsíc',
  datePicker_prev: () => 'Předchozí',
  datePicker_prevDecade: () => 'Předchozí desetiletí',
  datePicker_prevMonth: () => 'Předchozí měsíc',
  datePicker_restricted: () => 'Omezené',
  datePicker_selected: () => 'Vybráno',
  datePicker_today: () => 'Dnes',
  datePicker_weekNum: (p: { NUM: string }) => 'Týden ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Číslo týdne',
  datePicker_year: () => 'Rok',
  datePicker_years: () => 'Roky',
  diagram_promotedLink: () => '1 odkaz',
  diagram_promotedLinkAriaDesc: () => 'Nepřímý',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' odkazy (odkazů)',
  error: () => 'Chyba',
  expandableList_expandCollapseInstructionText: () =>
    'Pomocí kláves se šipkami obsah rozbalíte a sbalíte',
  expandableList_groupCollapse: () => 'Sbaleno',
  expandableList_groupExpand: () => 'Rozbaleno',
  filePicker_addFiles: () => 'Přidat soubory',
  filePicker_dropzonePrimaryText: () => 'Přetáhnout',
  filePicker_dropzoneSecondaryText: () => 'Vyberte soubor, nebo jej přetáhněte sem',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vyberte, nebo přetáhněte soubor sem',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nelze odesílat soubory typu: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Odesílejte pouze po jednom souboru',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nelze odesílat soubory typu ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'neznámý',
  formControl_clear: () => 'Vymazat',
  formControl_day: () => 'Den',
  formControl_empty_segment: () => 'Prázdné',
  formControl_helpAvailable: () => 'Je dostupná nápověda',
  formControl_hide: () => 'Skrýt',
  formControl_hour: () => 'hodina',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dosáhli jste limitu ' +
    ((
      {
        one: new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znak',
        few: new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znaky',
        many: new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znaku'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('cs').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znaků') +
    '.',
  formControl_loading: () => 'Načítání',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Můžete zadat až následující počet znaků: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximální délka ' + p['MAX_LENGTH'] + ' překročena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' zbývajících znaků.',
  formControl_millisecond: () => 'Milisekunda',
  formControl_minute: () => 'Minuta',
  formControl_month: () => 'Měsíc',
  formControl_readOnly: () => 'Pouze ke čtení',
  formControl_requiredMessageDetail: () => 'Zadejte hodnotu.',
  formControl_second: () => 'Sekunda',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Vyberte hodnoty (' + p['n'] + ').',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Dosáhli jste limitu (' + p['max'] + ') pro výběr.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Vyberte počet hodnot od ' + p['min'] + ' do ' + p['max'] + '.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Vyberte alespoň minimum (' + p['min'] + ') hodnot.',
  formControl_show: () => 'Zobrazit',
  formControl_year: () => 'Rok',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Konec',
  gantt_labelLabel: () => 'Popisek',
  gantt_labelRow: () => 'Řádka',
  gantt_labelStart: () => 'Začátek',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nebyl nalezen žádný odpovídající oddíl.',
  indexer_keyboardInstructionText: () => 'Stisknutím klávesy Enter vyberte hodnotu.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mezi ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvojitým klepnutím a přidržením přejděte do režimu gest, poté tažením nahoru nebo dolů upravte hodnotu.',
  info: () => 'Informace',
  inputColor_selectColor: () => 'Vybrat barvu',
  inputDateMask_date_cleared: () => 'Datum zúčtování',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prázdné',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'rrrr',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Zadejte datum shodné s ' + p['max'] + ' nebo dřívější.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Zadejte datum shodné s ' + p['min'] + ' nebo pozdější.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Zadejte dostupné datum.',
  inputDatePicker_instruction: () => 'Stisknutím klávesy Tab otevřete kalendář.',
  inputDatePicker_selectDate: () => 'Vyberte datum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Zadejte měsíc a rok ' + p['max'] + ' nebo dřívější.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Zadejte měsíc a rok ' + p['min'] + ' nebo pozdější.',
  inputNumber_converterParseError: () => 'Zadejte číslo.',
  inputNumber_decrease: () => 'Snížení',
  inputNumber_increase: () => 'Zvýšení',
  inputPassword_hidden: () => 'Heslo skryté',
  inputPassword_hide: () => 'Skrýt heslo',
  inputPassword_show: () => 'Zobrazit heslo',
  inputSensitiveText_hidden: () => 'Citlivý text je skryt',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Zadejte čas shodný s ' + p['max'] + ' nebo dřívější.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Zadejte čas shodný s ' + p['min'] + ' nebo pozdější.',
  inputTimeMask_time_cleared: () => 'Čas vymazání',
  labelNone: () => 'Žádné',
  list_msgFetchCompleted: () => 'Načteno',
  list_msgFetchingData: () => 'Načítání',
  list_suggestion: () => 'Doporučení',
  menu_stateLoading: () => 'Načítání',
  messageToast_allMessagesClosed: () => 'Všechny informační zprávy jsou zavřeny.',
  message_close: () => 'Zavřít',
  message_confirmation: () => 'Úspěch',
  message_error: () => 'Chyba',
  message_info: () => 'Informace',
  message_navigationFromMessagesRegion: () =>
    'Vstupujete do oblasti zpráv. Stisknutím klávesy F6 můžete přecházet.',
  message_navigationToMessagesRegion: () =>
    'V oblasti zpráv se nacházejí nové zprávy. Stisknutím klávesy F6 k ní přejděte.',
  message_navigationToTouch: () => 'V oblasti zpráv se nacházejí nové zprávy.',
  message_warning: () => 'Varování',
  noData_message: () => 'Neexistují položky k zobrazení',
  overflowItemLabel: () => 'Další karty',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Poklepáním zavřete otevřenou rozevírací nabídku.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Vstupujete do rozevírací nabídky. Stisknutím F6 můžete přecházet mezi rozevírací nabídkou a přiřazeným ovládacím prvkem.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Rozevírací nabídka je otevřena. Stisknutím F6 můžete přecházet mezi rozevírací nabídkou a přiřazeným ovládacím prvkem.',
  progressIndeterminate: () => 'Probíhá',
  radioButton_checked: () => 'Přepínač je zaškrtnut',
  radioButton_selected: () => 'Přepínač je vybrán',
  radioButton_unchecked: () => 'Přepínač není zaškrtnut',
  radioButton_unselected: () => 'Přepínač není vybrán',
  radio_helpForRadio: () => 'Nápověda k přepínači',
  radio_requiredMessageDetail: () => 'Vyberte hodnotu.',
  selectMultiple_apply: () => 'Použít',
  selectMultiple_back: () => 'Zpět',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Pomocí pravé a levé šipky zvýrazněte vybrané hodnoty.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Vybranou hodnotu odstraníte stisknutím klávesy Baskspace nebo Delete.',
  selectMultiple_selectedValues: () => 'Vybrané hodnoty',
  selectMultiple_showSelectedValues: () => 'Zobrazit pouze vybrané hodnoty.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' -  vybrané hodnoty.',
  select_addToList: () => 'Přidat do seznamu',
  select_addToListAvailable: () => 'Je dostupné přidání do seznamu',
  select_closeDropdown: () => 'Stisknutím klávesy Escape pro zavření.',
  select_moreSearchOptions: () => 'Další volby vyhledávání',
  select_moreSearchOptionsAvailable: () => 'Jsou dostupné další možnosti vyhledávání',
  select_noMatchesFound: () => 'Nebyly nalezeny žádné shody.',
  select_oneMatchFound: () => 'Nalezena jedna odpovídající položka',
  select_requiredMessageDetail: () => 'Vyberte hodnotu.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' - počet nalezených shod',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' nebo více shod nalezeno',
  selectorAll_deselectAll: () => 'Zrušit výběr všech',
  selectorAll_selectAll: () => 'Vybrat vše',
  selector_selected: () => 'Zaškrtávací políčko zaškrtnuto',
  selector_unselected: () => 'Zaškrtávací políčko nezaškrtnuto',
  sheet_close: () => 'Zavřít',
  switch_off: () => 'Vypnuto',
  switch_on: () => 'Zapnuto',
  tabBarNavigationList_removeCueText: () => 'Lze odebrat',
  tabBar_tabContainsErrors: () => 'Obsahuje chyby',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Odebrána vizualizace ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'má kontextovou nabídku',
  tabbar_labelMoveLeft: () => 'Posunout vlevo',
  tabbar_labelMoveRight: () => 'Posunout vpravo',
  tabbar_labelRemove: () => 'Odebrat',
  timeComponent_tooltipZoomIn: () => 'Přiblížit',
  timeComponent_tooltipZoomOut: () => 'Oddálit',
  timeConverter_parseError: () => 'Zadejte kompletní čas.',
  train_current: () => 'Aktuální',
  train_message_type: () => 'Typ zprávy',
  train_not_visited: () => 'Nenavštíveno',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Krok ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_visited: () => 'Navštíveno',
  userAssistance_learnMore: () => 'Další informace',
  userAssistance_required: () => 'Požadováno',
  vis_clearSelection: () => 'Zrušit výběr',
  vis_drillable: () => 'Lze procházet',
  vis_invalidData: () => 'Neplatná data',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' z celkem ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Rámeček výběru',
  vis_marqueeZoomTooltip: () => 'Rámeček lupy',
  vis_noData: () => 'Žádná data pro zobrazení',
  vis_panTooltip: () => 'Posunout',
  vis_stateCollapsed: () => 'Sbaleno',
  vis_stateExpanded: () => 'Rozbaleno',
  vis_stateLoaded: () => 'Načteno',
  vis_stateLoading: () => 'Načítání',
  vis_stateSelected: () => 'Vybráno',
  vis_stateUnselected: () => 'Výběr zrušen',
  warn: () => 'Varování'
};
export default bundle;
